/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-01 15:49:17
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-27 16:09:19
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/slice/index.ts
 */
/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-23 15:00:50
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-29 18:56:41
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/slice/index.ts
 */
import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import {
  generateDefaultState as _generateDefaultState,
  onCollapseOpen as _onCollapseOpen,
  assData,
  defaultStatus,
  hasError,
} from 'src/pages/SalesChannelProductsConfig/slice/reduxCommonFunctions';
import { msg } from 'src/tools/message';
import {
  EnumCollapseId,
  generateDefaultCustomisationButton,
  generateDefaultMockupImage,
  generateDefaultService,
} from '../common';

import {
  EnumReducers,
  getCollapseOpenStatus as _getCollapseOpenStatus,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getGeneralFeaturedProduct as _getGeneralFeaturedProduct,
  getHasModified as _getHasModified,
  getPageEnabled as _getPageEnabled,
  getSalesChannel as _getSalesChannel,
  getSalesChannelName as _getSalesChannelName,
  getSalesChannelProduct as _getSalesChannelProduct,
  getState as _getState,
  getSubmitStamp as _getSubmitStamp,
  getTarget,
  reducers,
} from 'src/pages/SalesChannelProductsConfig/slice/selectors';

import arrayMove from 'array-move';

export { EnumCollapseId };

import { getI18nFromGeneral } from '@/src/tools/tools';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';
import {
  convertDataFromServerToRedux,
  validationWhenSubmit,
} from 'src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/tools';
import {
  changeProductVisibility,
  deleteProduct,
  displayProduct,
  hideProduct,
} from 'src/pages/SalesChannelProductsConfig/slice/reduxCommonFunctions';
import {
  submitCustomization as _submitCustomization,
  getCustomization,
} from 'src/request/salesChannel/product';
import { history } from 'src/router/history';
//import { getTCs as _fetchTcs } from 'src/request/salesChannel/legal';
// import { EnumProductType } from 'src/types/common/product';

const fixedCollapse = [
  EnumCollapseId.mockupImage,
  EnumCollapseId.service,
  EnumCollapseId.customisationButton,
];
const fixedProps = { salesChannelProduct: {}, salesChannelProductUuid: '' };
const _defaultState = _generateDefaultState(fixedCollapse, fixedProps);
const mockupImage = generateDefaultMockupImage();
const service = generateDefaultService();
const customisationButton = generateDefaultCustomisationButton();
const defaultState = {
  loaded: false,
  enabled: false,
  mockupImage,
  service,
  customisationButton,
  ..._defaultState,
  ...defaultStatus,
  tcs: [],
  productServices: [],
};
const _currentReducer = reducers(EnumReducers.customization);

// export const fetchTcs = createAsyncThunk(
//   'submitSalesChannelProductCustomizationGetTCs',
//   async ({ uuid }: any) => {
//     const isPrimary = isCurrentPrimary();
//     const response = await _fetchTcs(uuid);
//     return { response, isPrimary };
//   },
// );

export const submitCustomization = createAsyncThunk(
  'submitSalesChannelProductCustomization',
  async ({ body, params }: any) => {
    const isPrimary = isCurrentPrimary();
    const response = await _submitCustomization(body, params);
    return { response, isPrimary };
  },
);

export const fetchCustomization = createAsyncThunk(
  'getSalesChannelProductCustomization',
  async ({ productUuid, params, isClone }: any) => {
    const isPrimary = isCurrentPrimary();
    const response = await getCustomization(productUuid, params);
    return { response, isPrimary, isClone };
  },
);

const salesChannelProductCustomization = createSlice({
  name: 'SalesChannelProductCustomization',
  initialState: defaultState,
  reducers: {
    onEnabledChange(state, action) {
      state.hasModified = true;
      state.enabled = action.payload;
    },
    onCollapseOpen(state, action) {
      const { idArr = [] } = action.payload; //=>[id:string]
      _onCollapseOpen(state, idArr);
    },
    onMockupImageOnChange(state, action) {
      state.hasModified = true;
      const { data } = action.payload;
      state.mockupImage = { ...state.mockupImage, ...data };
    },
    onMockupImageOnAdd(state, action) {
      state.hasModified = true;
      state.mockupImage.linkModules.push(...action.payload);
    },
    onMockupImageOnDelete(state, action) {
      state.hasModified = true;
      state.mockupImage.linkModules.splice(action.payload, 1);
    },
    onMockupImageOnSort(state, action) {
      const { from, to } = action.payload;
      state.hasModified = true;
      state.mockupImage.linkModules = arrayMove(
        state.mockupImage.linkModules,
        from,
        to,
      );
    },
    onMockupImageImgOnChange(state, action) {
      state.hasModified = true;
      const { index, data } = action.payload;
      state.mockupImage.linkModules[index] = {
        ...state.mockupImage.linkModules[index],
        ...data,
      };
    },
    onCustomisationButtonChange(state, action) {
      state.hasModified = true;
      state.customisationButton = {
        ...state.customisationButton,
        ...action.payload,
      };
    },
    onCustomisationButtonReset(state) {
      state.hasModified = true;
      state.customisationButton = generateDefaultCustomisationButton();
    },
    onServiceChange(state, action) {
      state.hasModified = true;
      const { data } = action.payload;
      state.service = { ...state.service, ...data };
    },
    onErrorChange(state, action) {
      const { id, status } = action.payload;
      state.collapseErrorMsgDisplay[id].hasError = status;
    },
    validation(state, action) {
      const { isPrimary } = action.payload;
      if (state.enabled) {
        hasError(state, state.collapseErrorMsgDisplay || {});
        validationWhenSubmit(state, isPrimary);
      } else {
        state.isDataValid = true;
      }
    },
    resetData(state) {
      assData(state, defaultState);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCustomization.fulfilled, (state, action) => {
      const { response, isClone, isPrimary } = action.payload;
      const { productServices } = response;
      state.productServices = productServices;
      const _data = convertDataFromServerToRedux(response, isPrimary) || {};

      assData(state, _data);
      if (isClone) state.hasModified = true;
    });
    builder.addCase(submitCustomization.fulfilled, (state, action) => {
      const { response, isPrimary } = action.payload;
      const _data = convertDataFromServerToRedux(response, isPrimary) || {};
      msg.success(getI18nFromGeneral('general.status.changessavesuccessfully'));
      assData(state, { ..._data });
    });
    builder.addCase(hideProduct.fulfilled, (state) => {
      changeProductVisibility(state, false);
    });
    builder.addCase(displayProduct.fulfilled, (state) => {
      changeProductVisibility(state, true);
    });
    builder.addCase(deleteProduct.fulfilled, (state) => {
      msg.success('Delete successfully');
      history.push(`/salesChannel/products/${state.salesChannelProductUuid}`);
    });
    // builder.addCase(fetchTcs.fulfilled, (state, action) => {
    //   const { response }: any = action.payload;
    //   const list = response.summaryList;
    //   state.tcs = list;
    // });
    // builder.addCase(fetchServices.fulfilled, (state, action) => {
    //   const { response } = action.payload;
    //   state.services = response || [];
    //   //changeProductVisibility(state, false);
    // });
  },
  //   extraReducers: (builder) => {

  //   },
});

export const getTCs = () => {
  return createSelector(
    (state: any) => getTarget(state, _currentReducer).tcs,
    (tcs) => {
      return tcs || [];
    },
  );
};

export const getServices = () => {
  return createSelector(
    (state: any) => getTarget(state, _currentReducer).productServices,
    (services) => {
      return services || [];
    },
  );
};

export const getSelectedServiceAndTc = (
  selectedServiceUuid,
  termsAndConditionsUuid,
) => {
  return createSelector(
    (state: any) => {
      const services = getTarget(state, _currentReducer).productServices || [];
      const terms = getTarget(state, _currentReducer).tcs || [];
      const service = services.find((i) => i.uuid === selectedServiceUuid);
      const tc = terms.find((i) => i.uuid === termsAndConditionsUuid);

      return { tc, service };
    },
    (res) => {
      return res;
    },
  );
};

export const getPageEnabled = () => {
  return _getPageEnabled(EnumReducers.customization);
};

export const getMockupImage = () => {
  return createSelector(
    (state: any) => getTarget(state, _currentReducer).mockupImage,
    (mockupImage) => {
      return mockupImage;
    },
  );
};
export const getCustomisationButton = () => {
  return createSelector(
    (state: any) => getTarget(state, _currentReducer).customisationButton,
    (customisationButton) => {
      return customisationButton;
    },
  );
};

export const getService = () => {
  return createSelector(
    (state: any) => getTarget(state, _currentReducer).service,
    (service) => {
      return service;
    },
  );
};

export const getCollapseOpenStatus = (id) => {
  return _getCollapseOpenStatus(EnumReducers.customization, id);
};

export const getCollapseValidationMsgDisplay = (id) => {
  return _getCollapseValidationMsgDisplay(EnumReducers.customization, id);
};

export const getGeneralFeaturedProduct = () => {
  return _getGeneralFeaturedProduct(EnumReducers.customization);
};

export const getState = () => {
  return _getState(EnumReducers.customization);
};

export const getHasModified = () => {
  return _getHasModified(EnumReducers.customization);
};

export const getSalesChannel = () => {
  return _getSalesChannel(EnumReducers.customization);
};

export const getSalesChannelName = () => {
  return _getSalesChannelName(EnumReducers.customization);
};

export const getSalesChannelProduct = () => {
  return _getSalesChannelProduct(EnumReducers.customization);
};

export const getSubmitStamp = () => {
  return _getSubmitStamp(EnumReducers.customization);
};
export const isCustomisationButtonBoardOpening = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.customization].collapseOpen[
        EnumCollapseId.customisationButton
      ],
    (open) => {
      return open;
    },
  );
};
export const {
  onEnabledChange,
  onCollapseOpen,
  onMockupImageOnChange,
  onMockupImageOnAdd,
  onMockupImageImgOnChange,
  onMockupImageOnDelete,
  onMockupImageOnSort,
  onErrorChange,
  onServiceChange,
  validation,
  onCustomisationButtonReset,
  onCustomisationButtonChange,
  resetData,
} = salesChannelProductCustomization.actions;

export default salesChannelProductCustomization.reducer;
